import * as React from "react";
import { line } from "./timeline-line.module.css";

const TimelineLine = () => {
    return (
        <div className = {line}></div>
    )
} 

export default TimelineLine